import { AbstractControl } from '@angular/forms';

export function validateIsObject({ value }: AbstractControl): { object: true } | null {
  return value && typeof value === 'object' ? null : { object: true };
}
